import _ from 'lodash'
import React from 'react'
import { Label, Select } from 'semantic-ui-react'
import { Controller } from 'react-hook-form'
import { humanizeString } from '../lib/humanize-string'

const isErrorSelector = (errors:any) => (fieldName:string) => !!_.get(errors, `${fieldName}.message`);
const errorMessageSelector = (errors:any) => (fieldName:string) => isErrorSelector(fieldName) ? 
  _.get(errors, `${fieldName}.message`).replace(fieldName, humanizeString(fieldName)) : null;

const Readonly = ({ as, value }:any) => {
  return React.createElement(as, value ? {} : {style: { color: 'gray' }}, [value || "N/A"])
}

interface IControlledSelect {
  control: any
  name: string
  options: any
  label?: string
  placeholder?: string
  errors?: any
  readonly?: boolean
  search?: boolean
  selectProps?: any
  defaultValue?: any
  disabled?: boolean
  required?: boolean
  inline?: boolean
  onBlur?: any
}

export const ControlledSelect = (props: IControlledSelect) => {
  const isError = isErrorSelector(props.errors)(props.name)
  return (
    <Controller
      name={props.name}
      control={props.control}
      defaultValue={props.defaultValue}
      rules={{ required: props.required && 'This field is required' }}
      render={({ onChange, value, name }) => {
        const readonlyValue = props.options.find((option:any) => option.value === (value || props.defaultValue))?.text;
        // const selectedValue = props.options.find((option:any) => option.text === (props.defaultValue))?.value;
        return (<>
          {props.label && <label htmlFor={name}>{props.label}</label>}
          {props.readonly && <Readonly as='span' value={readonlyValue}/>}
          {!props.readonly && (
            <Select
              id={name}
              placeholder={props.placeholder}
              name={name}
              error={isError}
              value={value}
              disabled={props.disabled}
              options={props.options.filter((option:any) => option.visible !== false)}
              onChange={(e, { value }) => {
                onChange(value)
                if (props.onBlur) {
                  props.onBlur();
                }
              }}
              {...props.selectProps}
            />
          )}
          {isError && <Label basic prompt pointing='above'>{errorMessageSelector(props.errors)(name)}</Label>}
        </>)
      }}
    />
  )
}

